import { useContext } from 'react';
import AddressContext from '../context/AddressContext';

const useAddress = () => useContext(AddressContext);

export default useAddress;
